import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './TextArea.module.css';

const lineHeight = 20;

export default class TextArea extends Component {
  constructor() {
    super();
    this.state = {rows: 1};
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.onChange(event.target.value);

    // To cause proper recalc when deleting lines
    const oldRows = event.target.rows;
    event.target.rows = 1;
    const newRows = ~~(event.target.scrollHeight / lineHeight);

    if (newRows === oldRows) {
      event.target.rows = newRows;
    }

    this.setState({
      rows: newRows,
    });
  }

  render() {
    return (
      <div className={styles.container}>
        <textarea
          value={this.props.value}
          rows={this.state.rows}
          className={`${styles.textArea} formInput`}
          placeholder={this.props.placeholder}
          onChange={this.handleChange}
          style={{lineHeight: `${lineHeight}px`}}
          maxLength={this.props.maxCharacters}
          autoFocus={this.props.autoFocus || false}
        />
        <label className="formLabel">{this.props.label} </label>
        {this.props.maxCharacters ? (
          <p className={styles.characterCount}>
            {this.props.value.length} / {this.props.maxCharacters}
          </p>
        ) : null}
        <p className="errorMessage">{this.props.error}</p>
      </div>
    );
  }
}

TextArea.defaultProps = {
  placeholder: 'Enter Description',
};

TextArea.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  maxChar: PropTypes.number, //Could switch to maxlength attribute
};
